
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _403Vw7xtXwDWGMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/403.vue?macro=true";
import { default as callback2RCJvse4V2Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/auth/callback.vue?macro=true";
import { default as confirmationYWXjDsVDKoMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/auth/confirmation.vue?macro=true";
import { default as defaultOGJdJLPXoOMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/auth/default.vue?macro=true";
import { default as recoveryKKhqSbvuVDMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/auth/recovery.vue?macro=true";
import { default as signature2nbQtA2Bs3Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/customer/timesheets/signature.vue?macro=true";
import { default as _91id_93irTOLBzcUwMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/advance-payment-requests/[id].vue?macro=true";
import { default as formu6hcWklcSdMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/advance-payment-requests/form.vue?macro=true";
import { default as indexw8fyjkCEriMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/advance-payment-requests/index.vue?macro=true";
import { default as _91id_93zRbhUOvyi0Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/advance-payment-requests/v2/[id].vue?macro=true";
import { default as admin_45modification_45requestedkRvWtYcT9MMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/amendments/[id]/admin-modification-requested.vue?macro=true";
import { default as consultant_45reviewdFvjcF2LhtMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/amendments/[id]/consultant-review.vue?macro=true";
import { default as indexPKs1G9gIB3Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/amendments/[id]/index.vue?macro=true";
import { default as modificationgmDbmxSo6NMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/amendments/[id]/modification.vue?macro=true";
import { default as reviewXZlhEBAyzoMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/amendments/[id]/review.vue?macro=true";
import { default as _91id_93WYBNL6d4FtMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/amendments/[id].vue?macro=true";
import { default as index0uPGzyXUeyMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/amendments/index.vue?macro=true";
import { default as indexKEATPIIQx6Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/applications/index.vue?macro=true";
import { default as indexc1i3IpeoUgMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/ats/index.vue?macro=true";
import { default as _91id_93NIgNMDjp42Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/ats/saved-search/[id].vue?macro=true";
import { default as search_45resultsORaEILoT5BMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/ats/search-results.vue?macro=true";
import { default as searchIQpuun1TWNMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/ats/search.vue?macro=true";
import { default as indexduigFyNVDfMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/calculator/index.vue?macro=true";
import { default as indexnI0BmtPnMHMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/calculators/index.vue?macro=true";
import { default as indexeJfAtrgtJnMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/commercial-conditions/index.vue?macro=true";
import { default as _91id_93kWuKkNvWuxMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/companies/[id].vue?macro=true";
import { default as indexZlXYsux0E3Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/companies/index.vue?macro=true";
import { default as indexYGJkcmpMgkMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/consultant-dashboard/index.vue?macro=true";
import { default as _91id_93cEGQEeJSqBMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/contacts/[id].vue?macro=true";
import { default as indexhUXHBlTyYpMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/contacts/index.vue?macro=true";
import { default as admin_45modification_45requestedLyvcW2Do4qMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/contracts/[id]/admin-modification-requested.vue?macro=true";
import { default as consultant_45review3UUYmB8K5BMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/contracts/[id]/consultant-review.vue?macro=true";
import { default as indexT6wuQ4BgcgMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/contracts/[id]/index.vue?macro=true";
import { default as modificationtC7M7YO1vKMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/contracts/[id]/modification.vue?macro=true";
import { default as reviewQLLnYldXA3Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/contracts/[id]/review.vue?macro=true";
import { default as _91id_93VPH7eax6Z6Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/contracts/[id].vue?macro=true";
import { default as index0M2qwH1pl0Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/contracts/index.vue?macro=true";
import { default as indexoyj5ArXevuMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/convert/index.vue?macro=true";
import { default as indexm1e8ixLMKIMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/cooptation/index.vue?macro=true";
import { default as action_45centerpYF7LJjXwzMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/dashboard/index/action-center.vue?macro=true";
import { default as indexcVdgfqPSjvMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/dashboard/index.vue?macro=true";
import { default as indexIqojWeR8KyMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/definitive-end-requests/index.vue?macro=true";
import { default as _91id_93FDUIhBAndcMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/expense-claim-requests/[id].vue?macro=true";
import { default as formvIxuubl1wfMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/expense-claim-requests/form.vue?macro=true";
import { default as indexD0xThoZdn4Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/expense-claim-requests/index.vue?macro=true";
import { default as _91id_93PdYaGdVJSNMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/expense-claim-requests/v2/[id].vue?macro=true";
import { default as _91id_93OwjpBAUWEBMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/independent-payment-requests/[id].vue?macro=true";
import { default as indexcJesXsrbD2Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/independent-payment-requests/index.vue?macro=true";
import { default as indexNwv8xWm9gmMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/index.vue?macro=true";
import { default as indexm72RPF89XlMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/invoice-simulator/index.vue?macro=true";
import { default as classificationXfcDQ17qFEMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/job-matrix/classification.vue?macro=true";
import { default as indexHGfK2k4xu4Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/job-matrix/index.vue?macro=true";
import { default as indexrZi4y4UmQiMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/meal-card-requests/index.vue?macro=true";
import { default as indexugn5RrfpfHMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/medical-centers/index.vue?macro=true";
import { default as _91id_93e2NHCeFtUVMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/medical-checkup-requests/[id].vue?macro=true";
import { default as formt1n5N80NdBMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/medical-checkup-requests/form.vue?macro=true";
import { default as indexus10NOBtk8Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/medical-checkup-requests/index.vue?macro=true";
import { default as applicationsfjrxzgI2dhMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/missions/[id]/applications.vue?macro=true";
import { default as detailsA3EISulhulMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/missions/[id]/details.vue?macro=true";
import { default as find_45talents9VMlc64ZapMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/missions/[id]/find-talents.vue?macro=true";
import { default as job_45postingNaA252Rdj8Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/missions/[id]/job-posting.vue?macro=true";
import { default as notesPYW0wSlEpjMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/missions/[id]/notes.vue?macro=true";
import { default as _91id_93aCUyeErj9BMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/missions/[id].vue?macro=true";
import { default as client_45orderywEWKl6NbwMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/missions/client-order.vue?macro=true";
import { default as formqm6nJT6d5VMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/missions/form.vue?macro=true";
import { default as indexF5uw8grGMTMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/missions/index.vue?macro=true";
import { default as talent_45poolingqY2vIyJujKMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/missions/talent-pooling.vue?macro=true";
import { default as indexy7e45jXFg0Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/organigram/index.vue?macro=true";
import { default as _91id_931ynPJhub8lMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/pay-tracking/[id].vue?macro=true";
import { default as indexfAqlgKhIukMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/pay-tracking/index.vue?macro=true";
import { default as _91contract_key_938VzEsRfCbaMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/planning/[contract_key].vue?macro=true";
import { default as index6kgN3ISDoxMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/planning/index.vue?macro=true";
import { default as indexIHASAhNjpAMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/ppe-requests/index.vue?macro=true";
import { default as _91id_93Ia4muquo5nMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/professional-card-requests/[id].vue?macro=true";
import { default as indexvaT7G0lITQMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/professional-card-requests/index.vue?macro=true";
import { default as _91id_93wGp9dmacoqMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/qualification-centers/[id].vue?macro=true";
import { default as indexP5GbXI2XlSMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/qualification-centers/index.vue?macro=true";
import { default as _91id_93WT0bI8XT4pMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/qualification-training-requests/[id].vue?macro=true";
import { default as index50g8mfbOHPMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/qualification-training-requests/index.vue?macro=true";
import { default as _91id_93E8vCwZPNURMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/recruitment-office-invoice-requests/[id].vue?macro=true";
import { default as index72cBlNHqDRMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/recruitment-office-invoice-requests/index.vue?macro=true";
import { default as indexoKKTCZ0xasMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/recruitment-office-invoice-requests/v2/index.vue?macro=true";
import { default as index4UW7kJG33IMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/reference-checks/index.vue?macro=true";
import { default as prepareVdTTFDrxWaMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/seed-scenarios/prepare.vue?macro=true";
import { default as indexJZCc5hCroJMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/deep-research/index.vue?macro=true";
import { default as refineVMELuaSLaxMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/deep-research/refine.vue?macro=true";
import { default as resultsg9m6S5FKdOMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/deep-research/results.vue?macro=true";
import { default as anonymous_45biotfVvitOUEAMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id]/anonymous-bio.vue?macro=true";
import { default as anonymous_45resume5Lo3ft6OeaMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id]/anonymous-resume.vue?macro=true";
import { default as applicationsPOqqfQG0WWMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id]/applications.vue?macro=true";
import { default as contractsQS3cTkiMlfMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id]/contracts.vue?macro=true";
import { default as detailsdw3BHC19awMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id]/details.vue?macro=true";
import { default as documentsk2bscGS2y0Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id]/documents.vue?macro=true";
import { default as find_45missions9ToifUMHTOMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id]/find-missions.vue?macro=true";
import { default as notesvjXwVNskHfMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id]/notes.vue?macro=true";
import { default as qualificationBtLSMdC4rEMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id]/qualification.vue?macro=true";
import { default as resumefJqW8hegtVMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id]/resume.vue?macro=true";
import { default as tasksxbcumpXDcFMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id]/tasks.vue?macro=true";
import { default as _91id_93Y4ezTkCoksMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id].vue?macro=true";
import { default as detailsP2T8AQLbQMMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/hiring-pools/[id]/details.vue?macro=true";
import { default as indexU7ja9lLloRMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/hiring-pools/index.vue?macro=true";
import { default as list_45v2sNSvAXMKgIMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/list-v2.vue?macro=true";
import { default as listE1kNkSHLnQMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/list.vue?macro=true";
import { default as push_45marketingVWU0IPJIzyMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/push-marketing.vue?macro=true";
import { default as substitute_45benchRMrd4XoY1ZMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/substitute-bench.vue?macro=true";
import { default as super_45search5JHAUF22q7Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/super-search.vue?macro=true";
import { default as index4UzeNGmoW5Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index.vue?macro=true";
import { default as indexfJtMWGKaVFMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/tasks/index.vue?macro=true";
import { default as indext94n6HWRZnMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/team-members/index.vue?macro=true";
import { default as _91id_93K85muK0mnVMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/third-party-notices/[id].vue?macro=true";
import { default as form37lHeblgGBMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/third-party-notices/form.vue?macro=true";
import { default as indexh7GIvJIFiCMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/third-party-notices/index.vue?macro=true";
import { default as third_45party_45noticesOnqsmxawv8Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/third-party-notices.vue?macro=true";
import { default as index5YwkZVbhbaMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/timesheets/index.vue?macro=true";
import { default as indexBh3hZN6bFaMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/users/index.vue?macro=true";
import { default as _91id_937SELk0WncwMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/work-accident-requests/[id].vue?macro=true";
import { default as editrnf5UzAVu9Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/work-accident-requests/edit.vue?macro=true";
import { default as formhLN7IeoHUYMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/work-accident-requests/form.vue?macro=true";
import { default as index3m9KL26LVrMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/work-accident-requests/index.vue?macro=true";
import { default as _91id_93BmkgZmTARgMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/work-accident-requests/v2/[id].vue?macro=true";
import { default as index8jIoGrNOBWMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index.vue?macro=true";
import { default as accountdkcdl5caRFMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/settings/index/account.vue?macro=true";
import { default as manageeskDsc37WeJpMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/settings/index/managees.vue?macro=true";
import { default as membersv6yyWHlA4fMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/settings/index/members.vue?macro=true";
import { default as workspaceaXKTS6o3eNMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/settings/index/workspace.vue?macro=true";
import { default as indexnxumVsqc1cMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index/settings/index.vue?macro=true";
import { default as indexNESpzT53UZMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/index.vue?macro=true";
import { default as loginGq3k4gr1juMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/login.vue?macro=true";
import { default as logoutmLDxJjWuKvMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/logout.vue?macro=true";
import { default as onboardingukPoRhhUl9Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/onboarding.vue?macro=true";
import { default as document_45processingS8LFvaH6wSMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/playground/document-processing.vue?macro=true";
import { default as factobukdciTd7sMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/playground/facto.vue?macro=true";
import { default as iban_45extractorzfZs9pIdT7Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/playground/iban-extractor.vue?macro=true";
import { default as index0tvrhMAY16Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/playground/index.vue?macro=true";
import { default as posthogtFdFKfl3dbMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/playground/posthog.vue?macro=true";
import { default as sentry_45nuxtjhLHnwtxUFMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/playground/sentry-nuxt.vue?macro=true";
import { default as sipsim5skiJTpaxlMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/playground/sipsim.vue?macro=true";
import { default as sms_45reminderOjNAYmuxduMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/playground/sms-reminder.vue?macro=true";
import { default as smspvPmII6HtXMeta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/playground/sms.vue?macro=true";
import { default as playgroundR54uHFnbk5Meta } from "/home/runner/_work/back-office/back-office/apps/back-office/pages/playground.vue?macro=true";
export default [
  {
    name: "403",
    path: "/403",
    meta: _403Vw7xtXwDWGMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/403.vue")
  },
  {
    name: "auth-callback",
    path: "/auth/callback",
    meta: callback2RCJvse4V2Meta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/auth/callback.vue")
  },
  {
    name: "auth-confirmation",
    path: "/auth/confirmation",
    meta: confirmationYWXjDsVDKoMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/auth/confirmation.vue")
  },
  {
    name: "auth-default",
    path: "/auth/default",
    meta: defaultOGJdJLPXoOMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/auth/default.vue")
  },
  {
    name: "auth-recovery",
    path: "/auth/recovery",
    meta: recoveryKKhqSbvuVDMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/auth/recovery.vue")
  },
  {
    name: "customer-timesheets-signature",
    path: "/customer/timesheets/signature",
    meta: signature2nbQtA2Bs3Meta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/customer/timesheets/signature.vue")
  },
  {
    name: indexNESpzT53UZMeta?.name,
    path: "/",
    meta: indexNESpzT53UZMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index.vue"),
    children: [
  {
    name: index8jIoGrNOBWMeta?.name,
    path: "",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index.vue"),
    children: [
  {
    name: "index-index-advance-payment-requests-id",
    path: "advance-payment-requests/:id()",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/advance-payment-requests/[id].vue")
  },
  {
    name: "index-index-advance-payment-requests-form",
    path: "advance-payment-requests/form",
    meta: formu6hcWklcSdMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/advance-payment-requests/form.vue")
  },
  {
    name: "index-index-advance-payment-requests",
    path: "advance-payment-requests",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/advance-payment-requests/index.vue")
  },
  {
    name: "index-index-advance-payment-requests-v2-id",
    path: "advance-payment-requests/v2/:id()",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/advance-payment-requests/v2/[id].vue")
  },
  {
    name: _91id_93WYBNL6d4FtMeta?.name,
    path: "amendments/:id()",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/amendments/[id].vue"),
    children: [
  {
    name: "index-index-amendments-id-admin-modification-requested",
    path: "admin-modification-requested",
    meta: admin_45modification_45requestedkRvWtYcT9MMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/amendments/[id]/admin-modification-requested.vue")
  },
  {
    name: "index-index-amendments-id-consultant-review",
    path: "consultant-review",
    meta: consultant_45reviewdFvjcF2LhtMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/amendments/[id]/consultant-review.vue")
  },
  {
    name: "index-index-amendments-id",
    path: "",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/amendments/[id]/index.vue")
  },
  {
    name: "index-index-amendments-id-modification",
    path: "modification",
    meta: modificationgmDbmxSo6NMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/amendments/[id]/modification.vue")
  },
  {
    name: "index-index-amendments-id-review",
    path: "review",
    meta: reviewXZlhEBAyzoMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/amendments/[id]/review.vue")
  }
]
  },
  {
    name: "index-index-amendments",
    path: "amendments",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/amendments/index.vue")
  },
  {
    name: "index-index-applications",
    path: "applications",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/applications/index.vue")
  },
  {
    name: "index-index-ats",
    path: "ats",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/ats/index.vue")
  },
  {
    name: "index-index-ats-saved-search-id",
    path: "ats/saved-search/:id()",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/ats/saved-search/[id].vue")
  },
  {
    name: "index-index-ats-search-results",
    path: "ats/search-results",
    meta: search_45resultsORaEILoT5BMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/ats/search-results.vue")
  },
  {
    name: "index-index-ats-search",
    path: "ats/search",
    meta: searchIQpuun1TWNMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/ats/search.vue")
  },
  {
    name: "index-index-calculator",
    path: "calculator",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/calculator/index.vue")
  },
  {
    name: "index-index-calculators",
    path: "calculators",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/calculators/index.vue")
  },
  {
    name: "index-index-commercial-conditions",
    path: "commercial-conditions",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/commercial-conditions/index.vue")
  },
  {
    name: "index-index-companies-id",
    path: "companies/:id()",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/companies/[id].vue")
  },
  {
    name: "index-index-companies",
    path: "companies",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/companies/index.vue")
  },
  {
    name: "index-index-consultant-dashboard",
    path: "consultant-dashboard",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/consultant-dashboard/index.vue")
  },
  {
    name: "index-index-contacts-id",
    path: "contacts/:id()",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/contacts/[id].vue")
  },
  {
    name: "index-index-contacts",
    path: "contacts",
    meta: indexhUXHBlTyYpMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/contacts/index.vue")
  },
  {
    name: _91id_93VPH7eax6Z6Meta?.name,
    path: "contracts/:id()",
    meta: _91id_93VPH7eax6Z6Meta || {},
    redirect: _91id_93VPH7eax6Z6Meta?.redirect,
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/contracts/[id].vue"),
    children: [
  {
    name: "index-index-contracts-id-admin-modification-requested",
    path: "admin-modification-requested",
    meta: admin_45modification_45requestedLyvcW2Do4qMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/contracts/[id]/admin-modification-requested.vue")
  },
  {
    name: "index-index-contracts-id-consultant-review",
    path: "consultant-review",
    meta: consultant_45review3UUYmB8K5BMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/contracts/[id]/consultant-review.vue")
  },
  {
    name: "index-index-contracts-id",
    path: "",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/contracts/[id]/index.vue")
  },
  {
    name: "index-index-contracts-id-modification",
    path: "modification",
    meta: modificationtC7M7YO1vKMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/contracts/[id]/modification.vue")
  },
  {
    name: "index-index-contracts-id-review",
    path: "review",
    meta: reviewQLLnYldXA3Meta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/contracts/[id]/review.vue")
  }
]
  },
  {
    name: "index-index-contracts",
    path: "contracts",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/contracts/index.vue")
  },
  {
    name: "index-index-convert",
    path: "convert",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/convert/index.vue")
  },
  {
    name: "index-index-cooptation",
    path: "cooptation",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/cooptation/index.vue")
  },
  {
    name: "index-index-dashboard",
    path: "dashboard",
    meta: indexcVdgfqPSjvMeta || {},
    redirect: indexcVdgfqPSjvMeta?.redirect,
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/dashboard/index.vue"),
    children: [
  {
    name: "index-index-dashboard-index-action-center",
    path: "action-center",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/dashboard/index/action-center.vue")
  }
]
  },
  {
    name: "index-index-definitive-end-requests",
    path: "definitive-end-requests",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/definitive-end-requests/index.vue")
  },
  {
    name: "index-index-expense-claim-requests-id",
    path: "expense-claim-requests/:id()",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/expense-claim-requests/[id].vue")
  },
  {
    name: "index-index-expense-claim-requests-form",
    path: "expense-claim-requests/form",
    meta: formvIxuubl1wfMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/expense-claim-requests/form.vue")
  },
  {
    name: "index-index-expense-claim-requests",
    path: "expense-claim-requests",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/expense-claim-requests/index.vue")
  },
  {
    name: "index-index-expense-claim-requests-v2-id",
    path: "expense-claim-requests/v2/:id()",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/expense-claim-requests/v2/[id].vue")
  },
  {
    name: "index-index-independent-payment-requests-id",
    path: "independent-payment-requests/:id()",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/independent-payment-requests/[id].vue")
  },
  {
    name: "index-index-independent-payment-requests",
    path: "independent-payment-requests",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/independent-payment-requests/index.vue")
  },
  {
    name: "index-index",
    path: "",
    meta: indexNwv8xWm9gmMeta || {},
    redirect: "/dashboard/action-center",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/index.vue")
  },
  {
    name: "index-index-invoice-simulator",
    path: "invoice-simulator",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/invoice-simulator/index.vue")
  },
  {
    name: "index-index-job-matrix-classification",
    path: "job-matrix/classification",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/job-matrix/classification.vue")
  },
  {
    name: "index-index-job-matrix",
    path: "job-matrix",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/job-matrix/index.vue")
  },
  {
    name: "index-index-meal-card-requests",
    path: "meal-card-requests",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/meal-card-requests/index.vue")
  },
  {
    name: "index-index-medical-centers",
    path: "medical-centers",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/medical-centers/index.vue")
  },
  {
    name: "index-index-medical-checkup-requests-id",
    path: "medical-checkup-requests/:id()",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/medical-checkup-requests/[id].vue")
  },
  {
    name: "index-index-medical-checkup-requests-form",
    path: "medical-checkup-requests/form",
    meta: formt1n5N80NdBMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/medical-checkup-requests/form.vue")
  },
  {
    name: "index-index-medical-checkup-requests",
    path: "medical-checkup-requests",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/medical-checkup-requests/index.vue")
  },
  {
    name: "index-index-missions-id",
    path: "missions/:id()",
    meta: _91id_93aCUyeErj9BMeta || {},
    redirect: _91id_93aCUyeErj9BMeta?.redirect,
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/missions/[id].vue"),
    children: [
  {
    name: "index-index-missions-id-applications",
    path: "applications",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/missions/[id]/applications.vue")
  },
  {
    name: "index-index-missions-id-details",
    path: "details",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/missions/[id]/details.vue")
  },
  {
    name: "index-index-missions-id-find-talents",
    path: "find-talents",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/missions/[id]/find-talents.vue")
  },
  {
    name: "index-index-missions-id-job-posting",
    path: "job-posting",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/missions/[id]/job-posting.vue")
  },
  {
    name: "index-index-missions-id-notes",
    path: "notes",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/missions/[id]/notes.vue")
  }
]
  },
  {
    name: "index-index-missions-client-order",
    path: "missions/client-order",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/missions/client-order.vue")
  },
  {
    name: "index-index-missions-form",
    path: "missions/form",
    meta: formqm6nJT6d5VMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/missions/form.vue")
  },
  {
    name: "index-index-missions",
    path: "missions",
    meta: indexF5uw8grGMTMeta || {},
    redirect: "/missions/client-order",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/missions/index.vue")
  },
  {
    name: "index-index-missions-talent-pooling",
    path: "missions/talent-pooling",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/missions/talent-pooling.vue")
  },
  {
    name: "index-index-organigram",
    path: "organigram",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/organigram/index.vue")
  },
  {
    name: "index-index-pay-tracking-id",
    path: "pay-tracking/:id()",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/pay-tracking/[id].vue")
  },
  {
    name: "index-index-pay-tracking",
    path: "pay-tracking",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/pay-tracking/index.vue")
  },
  {
    name: "index-index-planning-contract_key",
    path: "planning/:contract_key()",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/planning/[contract_key].vue")
  },
  {
    name: "index-index-planning",
    path: "planning",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/planning/index.vue")
  },
  {
    name: "index-index-ppe-requests",
    path: "ppe-requests",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/ppe-requests/index.vue")
  },
  {
    name: "index-index-professional-card-requests-id",
    path: "professional-card-requests/:id()",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/professional-card-requests/[id].vue")
  },
  {
    name: "index-index-professional-card-requests",
    path: "professional-card-requests",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/professional-card-requests/index.vue")
  },
  {
    name: "index-index-qualification-centers-id",
    path: "qualification-centers/:id()",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/qualification-centers/[id].vue")
  },
  {
    name: "index-index-qualification-centers",
    path: "qualification-centers",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/qualification-centers/index.vue")
  },
  {
    name: "index-index-qualification-training-requests-id",
    path: "qualification-training-requests/:id()",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/qualification-training-requests/[id].vue")
  },
  {
    name: "index-index-qualification-training-requests",
    path: "qualification-training-requests",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/qualification-training-requests/index.vue")
  },
  {
    name: "index-index-recruitment-office-invoice-requests-id",
    path: "recruitment-office-invoice-requests/:id()",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/recruitment-office-invoice-requests/[id].vue")
  },
  {
    name: "index-index-recruitment-office-invoice-requests",
    path: "recruitment-office-invoice-requests",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/recruitment-office-invoice-requests/index.vue")
  },
  {
    name: "index-index-recruitment-office-invoice-requests-v2",
    path: "recruitment-office-invoice-requests/v2",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/recruitment-office-invoice-requests/v2/index.vue")
  },
  {
    name: "index-index-reference-checks",
    path: "reference-checks",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/reference-checks/index.vue")
  },
  {
    name: "index-index-seed-scenarios-prepare",
    path: "seed-scenarios/prepare",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/seed-scenarios/prepare.vue")
  },
  {
    name: "index-index-talents-deep-research",
    path: "talents/deep-research",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/deep-research/index.vue")
  },
  {
    name: "index-index-talents-deep-research-refine",
    path: "talents/deep-research/refine",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/deep-research/refine.vue")
  },
  {
    name: "index-index-talents-deep-research-results",
    path: "talents/deep-research/results",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/deep-research/results.vue")
  },
  {
    name: "index-index-talents",
    path: "talents",
    meta: index4UzeNGmoW5Meta || {},
    redirect: index4UzeNGmoW5Meta?.redirect,
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index.vue"),
    children: [
  {
    name: "index-index-talents-index-id",
    path: ":id()",
    meta: _91id_93Y4ezTkCoksMeta || {},
    redirect: _91id_93Y4ezTkCoksMeta?.redirect,
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id].vue"),
    children: [
  {
    name: "index-index-talents-index-id-anonymous-bio",
    path: "anonymous-bio",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id]/anonymous-bio.vue")
  },
  {
    name: "index-index-talents-index-id-anonymous-resume",
    path: "anonymous-resume",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id]/anonymous-resume.vue")
  },
  {
    name: "index-index-talents-index-id-applications",
    path: "applications",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id]/applications.vue")
  },
  {
    name: "index-index-talents-index-id-contracts",
    path: "contracts",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id]/contracts.vue")
  },
  {
    name: "index-index-talents-index-id-details",
    path: "details",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id]/details.vue")
  },
  {
    name: "index-index-talents-index-id-documents",
    path: "documents",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id]/documents.vue")
  },
  {
    name: "index-index-talents-index-id-find-missions",
    path: "find-missions",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id]/find-missions.vue")
  },
  {
    name: "index-index-talents-index-id-notes",
    path: "notes",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id]/notes.vue")
  },
  {
    name: "index-index-talents-index-id-qualification",
    path: "qualification",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id]/qualification.vue")
  },
  {
    name: "index-index-talents-index-id-resume",
    path: "resume",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id]/resume.vue")
  },
  {
    name: "index-index-talents-index-id-tasks",
    path: "tasks",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/[id]/tasks.vue")
  }
]
  },
  {
    name: "index-index-talents-index-hiring-pools-id-details",
    path: "hiring-pools/:id()/details",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/hiring-pools/[id]/details.vue")
  },
  {
    name: "index-index-talents-index-hiring-pools",
    path: "hiring-pools",
    meta: indexU7ja9lLloRMeta || {},
    redirect: "/ats",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/hiring-pools/index.vue")
  },
  {
    name: "index-index-talents-index-list-v2",
    path: "list-v2",
    meta: list_45v2sNSvAXMKgIMeta || {},
    redirect: "/ats",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/list-v2.vue")
  },
  {
    name: "index-index-talents-index-list",
    path: "list",
    meta: listE1kNkSHLnQMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/list.vue")
  },
  {
    name: "index-index-talents-index-push-marketing",
    path: "push-marketing",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/push-marketing.vue")
  },
  {
    name: "index-index-talents-index-substitute-bench",
    path: "substitute-bench",
    meta: substitute_45benchRMrd4XoY1ZMeta || {},
    redirect: substitute_45benchRMrd4XoY1ZMeta?.redirect,
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/substitute-bench.vue")
  },
  {
    name: "index-index-talents-index-super-search",
    path: "super-search",
    meta: super_45search5JHAUF22q7Meta || {},
    redirect: "/ats",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/talents/index/super-search.vue")
  }
]
  },
  {
    name: "index-index-tasks",
    path: "tasks",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/tasks/index.vue")
  },
  {
    name: "index-index-team-members",
    path: "team-members",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/team-members/index.vue")
  },
  {
    name: third_45party_45noticesOnqsmxawv8Meta?.name,
    path: "third-party-notices",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/third-party-notices.vue"),
    children: [
  {
    name: "index-index-third-party-notices-id",
    path: ":id()",
    meta: _91id_93K85muK0mnVMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/third-party-notices/[id].vue")
  },
  {
    name: "index-index-third-party-notices-form",
    path: "form",
    meta: form37lHeblgGBMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/third-party-notices/form.vue")
  },
  {
    name: "index-index-third-party-notices",
    path: "",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/third-party-notices/index.vue")
  }
]
  },
  {
    name: "index-index-timesheets",
    path: "timesheets",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/timesheets/index.vue")
  },
  {
    name: "index-index-users",
    path: "users",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/users/index.vue")
  },
  {
    name: "index-index-work-accident-requests-id",
    path: "work-accident-requests/:id()",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/work-accident-requests/[id].vue")
  },
  {
    name: "index-index-work-accident-requests-edit",
    path: "work-accident-requests/edit",
    meta: editrnf5UzAVu9Meta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/work-accident-requests/edit.vue")
  },
  {
    name: "index-index-work-accident-requests-form",
    path: "work-accident-requests/form",
    meta: formhLN7IeoHUYMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/work-accident-requests/form.vue")
  },
  {
    name: "index-index-work-accident-requests",
    path: "work-accident-requests",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/work-accident-requests/index.vue")
  },
  {
    name: "index-index-work-accident-requests-v2-id",
    path: "work-accident-requests/v2/:id()",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/index/work-accident-requests/v2/[id].vue")
  }
]
  },
  {
    name: "index-settings",
    path: "settings",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/settings/index.vue"),
    children: [
  {
    name: "index-settings-index-account",
    path: "account",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/settings/index/account.vue")
  },
  {
    name: "index-settings-index-managees",
    path: "managees",
    meta: manageeskDsc37WeJpMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/settings/index/managees.vue")
  },
  {
    name: "index-settings-index-members",
    path: "members",
    meta: membersv6yyWHlA4fMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/settings/index/members.vue")
  },
  {
    name: "index-settings-index-workspace",
    path: "workspace",
    meta: workspaceaXKTS6o3eNMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/index/settings/index/workspace.vue")
  }
]
  }
]
  },
  {
    name: "login",
    path: "/login",
    meta: loginGq3k4gr1juMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logoutmLDxJjWuKvMeta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/logout.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: onboardingukPoRhhUl9Meta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/onboarding.vue")
  },
  {
    name: playgroundR54uHFnbk5Meta?.name,
    path: "/playground",
    meta: playgroundR54uHFnbk5Meta || {},
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/playground.vue"),
    children: [
  {
    name: "playground-document-processing",
    path: "document-processing",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/playground/document-processing.vue")
  },
  {
    name: "playground-facto",
    path: "facto",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/playground/facto.vue")
  },
  {
    name: "playground-iban-extractor",
    path: "iban-extractor",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/playground/iban-extractor.vue")
  },
  {
    name: "playground",
    path: "",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/playground/index.vue")
  },
  {
    name: "playground-posthog",
    path: "posthog",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/playground/posthog.vue")
  },
  {
    name: "playground-sentry-nuxt",
    path: "sentry-nuxt",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/playground/sentry-nuxt.vue")
  },
  {
    name: "playground-sipsim",
    path: "sipsim",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/playground/sipsim.vue")
  },
  {
    name: "playground-sms-reminder",
    path: "sms-reminder",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/playground/sms-reminder.vue")
  },
  {
    name: "playground-sms",
    path: "sms",
    component: () => import("/home/runner/_work/back-office/back-office/apps/back-office/pages/playground/sms.vue")
  }
]
  }
]